<template>
  <div class="center-warp">
    <div class="inner" v-loading="joinLoading">
      <div class="d-flex-between">
        <div class="scan-type">
          <div :class="caseListModule ? 'on' : ''" @click="caseListModule = true"><i class="iconfont icon-liebiaomoshi"></i>列表模式</div>
          <div :class="!caseListModule ? 'on' : ''" @click="caseListModule = false"><i class="iconfont icon-tupianmoshi"></i>图片模式</div>
        </div>
<!--        <div class="publish-btn flex-center-center" @click="goTo('/case_management/add_case')"><i-->
<!--          class="iconfont icon-xinzeng"></i>新增病例-->
<!--        </div>-->
      </div>
      <div class="filter-sort">
        <div v-for="(item,index) in orderList" :class="index == orderIndex ? 'on' : ''" class="filter-sort-item"
             @click="orderChange(index)">{{ item.name }}·
          <span @click.stop="orderSortChange(index)" class="hover-bg">{{ item.param_name[orderSortIndex[index]] }}<i class="iconfont icon-qiehuan"></i></span>
        </div>
      </div>

      <div class="detail-warp">
        <div ref="leftCaseRef" :class="isManage ? 'disClick' : ''"
             class="detail-warp-left">
          <!--    用户类型为医生0时，可以切换病例类型      -->
          <div class="choose-warp-left-filter">
            <div v-if="member.member_type == 0" class="choose-warp-left-nav">
              <div :class="case_type == 0 ? 'on' : ''" @click="changeCaseType(0)">咨询病例</div>
              <div :class="case_type == 1 ? 'on' : ''" @click="changeCaseType(1)">管理病例</div>
            </div>
            <div class="choose-warp-left-search d-flex-between">
<!--              <input type="text" placeholder="病例名称或病例编号" v-model="keyWords" @keydown.enter="initCaseData(true)">-->
              <Input :placeholder="'病例名称或病例编号'" v-model="keyWords" @enter="initCaseData(true)"/>
              <div class="iconfont icon-sousuo" @click="initCaseData(true)"></div>
            </div>
          </div>
          <div v-if="caseListModule">
            <div v-for="(item) in caseList" :class="caseDetailValue.id == item.id ? 'on' : ''" class="case-person hover-shadow"
                 @click="chooseCaseDetail(item)">
              <img v-if="item.difficulty_level" :src="item.difficulty_level == 'A' ? require('@/assets/img/doctor-detail/A.png') :
            item.difficulty_level == 'B' ? require('@/assets/img/doctor-detail/B.png') :
            item.difficulty_level == 'C' ? require('@/assets/img/doctor-detail/C.png') : ''
             " alt="" class="case-person-grade">
              <img v-if="item.finished_status == 1" alt="" class="case-person-state"
                   src="@/assets/img/doctor-detail/state-finished.png">
              <img v-if="!item.mentor_id && item.case_type == 0" alt="" class="case-person-state"
                   src="@/assets/img/doctor-detail/state-new.png">
              <div class="d-flex-between" style="align-items: center">
                <div class="case-person-name">{{ item.name }}
                  <div
                    v-if="item.show_red_dot"
                    class="new-dot"></div>
                </div>
                <div class="case-person-info">{{ item.age_text }}</div>
              </div>
              <div class="case-person-info">{{ item.no }}</div>
              <div class="case-person-time-line">
                <div class="case-person-time">
                  <img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">
                  {{ item.sz_date.substring(0, 11) }}
                </div>
                <div v-if="item.new_date" class="case-person-time-split"></div>
                <div v-if="item.new_date" class="case-person-time">
                  <img src="@/assets/img/doctor-detail/time-zuixin.png">
                  {{ item.new_date.substring(0, 11) }}
                </div>
              </div>
              <div :class="item.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'"
                   class="case-person-cycle package-tag">
                {{ item.confirm_first_case_type_text != '' ? item.confirm_first_case_type_text : item.first_case_type_name }}
              </div>
            </div>
          </div>
          <div class="d-flex-warp" v-else>
            <div v-for="(item) in caseList" class="case-person-other" :class="caseDetailValue.id == item.id ? 'on' : ''"  @click="chooseCaseDetail(item)">
              <img v-if="item.difficulty_level" :src="item.difficulty_level == 'A' ? require('@/assets/img/doctor-detail/A.png') :
            item.difficulty_level == 'B' ? require('@/assets/img/doctor-detail/B.png') :
            item.difficulty_level == 'C' ? require('@/assets/img/doctor-detail/C.png') : ''
             " alt="" class="case-person-grade">
              <img v-if="item.finished_status == 1" alt="" class="case-person-state"
                   src="@/assets/img/doctor-detail/state-finished.png">
              <img v-if="!item.mentor_id && item.case_type == 0" alt="" class="case-person-state"
                   src="@/assets/img/doctor-detail/state-new.png">
              <img class="case-person-other-img" :src="item.head_pic" alt="">
              <div class="case-person-other-name"><div class="limit-1">{{ item.name }}</div><div v-if="item.show_red_dot" class="new-dot"></div>  </div>
              <div class="case-person-info" style="text-align: center">{{ item.age_text }}</div>
            </div>
          </div>
          <div v-if="loadStatus" class="load-info"><i v-if="loadStatus == 'load'" class="el-icon-loading"></i><span
            v-if="loadStatus == 'load'">加载中</span><span v-if="loadStatus == 'over'">已经全部加载完成</span></div>
        </div>
        <div v-if="caseDetailValue.id"
             class="detail-warp-right">
          <div class="d-flex-between" style="align-items: center">
            <div class="case-person-info">
              <div>{{ caseDetailValue.name }}的资料卡</div>
            </div>
            <div v-if="!isManage" class="d-flex">
<!--              <div v-if="caseDetailValue.be_full_consult != 1 && member.member_type != 1" class="add-btn" @click="showCycleDialog = true">-->
<!--                解锁全周期-->
<!--              </div>-->
              <div class="add-btn" @click="goTo('/chat')" v-if="doctor_id != '' && caseDetailValue.im_group_id && caseDetailValue.mentor_id">进入对话</div>
              <div v-if="caseDetailValue.finished_status != 1 && member.member_type == 1" class="add-btn"
                   @click="createBigCase">{{ caseDetailValue.mentor_id  ? '生成大病案' : '立即协助' }}
              </div>
              <template v-if="member.member_type == 0 || doctor_id == ''">
                <div class="add-btn" @click="isManage = true"><i class="iconfont icon-guanliziliaoka"></i>管理资料卡
                </div>
                <div class="add-btn" @click="openAddDialog"><i class="iconfont icon-xinjian"></i>新建</div>
              </template>
            </div>
            <div v-if="isManage" class="d-flex">
              <div class="del-btn" @click="delCard"><i class="iconfont icon-shanchu"></i>删除</div>
              <div class="add-btn" @click="isManage = false">退出管理</div>
            </div>
          </div>
          <div class="case-person-type d-flex-between">
            <div v-for="item in typeNavList" :class="typeValue == item.id ? 'on' : ''" @click="changeType(item.id)">
              {{ item.name }}
            </div>
          </div>
          <div class="case-person-warp">
            <div v-if="cardloadStatus" class="load-info" style="width: 100%;"><i v-if="cardloadStatus == 'load'"
                                                                                 class="el-icon-loading"></i><span
              v-if="cardloadStatus == 'load'">加载中</span><span
              v-if="cardloadStatus == 'over'">数据全部加载完成</span></div>
            <template v-for="item in caseCardList">
              <div v-if="caseDetailValue.finished_status != 1 || ((item.type_id == 1 || item.type_id == 6 || item.type_id == 7) && caseDetailValue.finished_status == 1)" class="case-item"
                   @click="openCardPup(item,item.type_id)">
                <img :src="item.type_id == 1 || (caseDetailValue.finished_status == 1 && item.type_id == 1)? cardList.sz[0].url :
              item.type_id == 2 ? cardList.fz[0].url :
              item.type_id == 3 ? cardList.hz[0].url :
              item.type_id == 4 ? cardList.tx[0].url :
              item.type_id == 5 ? cardList.sj[0].url :
              item.type_id == 6 && caseDetailValue.confirm_first_case_type == 4 ? cardList.gnkl[0].url :
              item.type_id == 7 && caseDetailValue.confirm_first_case_type == 4 ? cardList.yxkl[0].url : cardList.jzq[0].url
              " alt="" class="case-item-img">
                <div v-if="item.show_not_pass" class="card-status iconfont icon-weitongguo">未通过</div>
                <div class="card-name">
                  <div :class="item.type_id == 1 && caseDetailValue.finished_status != 1?'dot-shouzhen' :
                     item.type_id == 2?'dot-fuzhen' :
                     item.type_id == 3?'dot-huizhen' :
                     item.type_id == 4?'dot-tuxiang' :
                     item.type_id == 5 || (caseDetailValue.finished_status == 1 && item.type_id == 1)?'dot-qixie' :
                     item.type_id == 6?'dot-jiaozhi' : 'dot-yinxing'
"
                       class="card-dot"></div>
                  {{ caseDetailValue.finished_status == 1 && item.type_id == 1 ? '大病案' : item.type_name }}
                </div>
                <div class="card-time">{{
                    caseDetailValue.finished_status == 1 && item.type_id == 1 ? caseDetailValue.finished_at.substring(0, 11) : item.card_date
                  }}
                </div>
                <div v-if="isManage && item.type_id != 1"
                     :class=" delCardIds.indexOf(item.id) != -1 ? 'icon-yixuan':'icon-weixuan'"
                     class="case-card-radio iconfont"></div>
              </div>
            </template>

          </div>
          <div class="bottom-times-count">
            本病例已领用耗材{{ caseDetailValue.hc_total_count }}件（含{{ caseDetailValue.hc_free_count }}次免费）
            <div class="bottom-times-count-btn" @click="openHcDialog">查看</div>
          </div>
        </div>
        <div v-if="!caseDetailValue.id" class="detail-warp-right default-center">
          <img alt="" class="default" src="@/assets/img/base/default.png">
        </div>
      </div>

      <!--      耗材领用情况弹窗-->
      <el-dialog
        :show-close="false"
        :visible.sync="showHcDialog"
        custom-class="take-dialog"
        width="600px">
        <div slot="title" class="dialog-title" style="display: block">
          <div>{{ caseDetailValue.name }}的套餐耗材领用情况</div>
          <div style="color: #8F8F8F;font-size: 14px;font-weight: 400">{{ caseDetailValue.no }}</div>
        </div>
        <div :class="caseDetailValue.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'"
             class="hc-tag package-tag">
          {{ caseDetailValue.confirm_first_case_type_text != '' ? caseDetailValue.confirm_first_case_type_text : caseDetailValue.first_case_type_name }}
        </div>
        <div class="hc-table">
          <div class="hc-table-line">
            <div>耗材分类</div>
            <div>套餐包含次数</div>
            <div>领用次数</div>
          </div>
          <div v-for="item in hcList" class="hc-table-line">
            <div>{{ item.product_category_name }}</div>
            <div>{{ item.can_free_count }}</div>
            <div>{{ item.product_quantity }}</div>
          </div>
        </div>
        <div class="hc-btn" @click="showHcDialog = false">确定</div>
      </el-dialog>

      <!--      新增资料卡弹窗-->
      <el-dialog
        :visible.sync="showAddDialog"
        custom-class="take-dialog"
        width="500px">
        <div slot="title" class="dialog-title">新增资料卡 <span>选择资料卡类型</span></div>
        <div class="d-flex-warp">
          <el-dialog
            :visible.sync="showDesignDioalog"
            append-to-body
            custom-class="take-dialog"
            width="340px">
            <div slot="title" class="dialog-title">选择模板 <span>新建的设计单模板</span></div>
            <div class="d-flex-between">
              <div v-for="item in designModel" class="design-item">
                <div :class="designType.id == item.id? 'design-item-on':''" class="design-item-img">
                  <!--                  <img :src="item.item_comment" alt="">-->
                  <el-image
                    :preview-src-list="[item.item_comment]"
                    :src="item.item_comment">
                  </el-image>
                  <div class="design-item-cover" @click="designType = item"></div>
                  <div class="design-item-eye">
                    <i class="iconfont icon-yulan"></i>
                  </div>
                </div>
                <div class="design-item-name" @click="designType = item">
                  <div :class="designType.id == item.id? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="take-dialog-bottom">
              <div class="take-dialog-close" @click="showDesignDioalog = false">取消</div>
              <div :class="designType.id ? '' : 'disClick'" class="take-dialog-open" @click="addDesignCard">确定</div>
            </div>
          </el-dialog>
          <div class="d-flex-warp">
            <div v-for="(item,index) in addTypeList" class="add-type" @click="addTypeChange(index)">
              <img v-if="item.isDL" alt="" class="add-type-tag" src="../../assets/img/case_management/dl-tag.png">
              <div :class="addType == index? 'on':''" class="add-type-info">
                <div class="add-type-name flex-center-center"><img
                  :src="require('../../assets/img/case_management/' + item.url)" alt="">{{ item.name }}
                </div>
                <div class="add-type-des">{{ item.des }}</div>
              </div>
              <div class="flex-center-center add-type-radio">
                <div :class="addType == index? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="take-dialog-bottom">
          <div class="take-dialog-close" @click="showAddDialog = false">取消</div>
          <div :class="addType == -1 ? 'disClick' : ''" class="take-dialog-open"
               @click="goTo('/case_management/add_card')">确定
          </div>
        </div>
      </el-dialog>

      <!--      资料卡详情弹窗-->
      <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showCaseCardDetail"
        custom-class="page-dialog"
        top="4vh"
        width="1104px">
        <el-dialog
          :visible.sync="innerVisible"
          append-to-body
          custom-class="take-dialog"
          title="内选择您要使用的服务"
          width="340px">
          <div class="service-warp">
            <div v-for="(item,index) in serviceList" :class="serviceIndex == index ? 'on' : ''"
                 @click="serviceChange(index)">{{ item }}
            </div>
          </div>
          <div class="take-dialog-bottom">
            <div class="take-dialog-close" @click="innerVisible = false">取消</div>
            <div class="take-dialog-open">确定</div>
          </div>
        </el-dialog>
        <div v-if="cardDetail.type_name" class="case-card-detail">

          <div class="case-card-detail-left">
            <div class="case-card-block">
              <div class="case-card-block-line" @click="menuChange('card')"><i
                class="iconfont icon-fanhui2"></i>{{ dialogMenu == 'card' ? '返回病历管理' : '返回资料卡' }}
              </div>
            </div>
<!--            <div class="case-card-block">-->
<!--              <div v-if="!isAnnotate" class="case-card-block-line" @click="goAnnotate"><i-->
<!--                class="iconfont icon-jinrupizhumoshi"></i>进入批注模式-->
<!--              </div>-->
<!--              <div v-if="isAnnotate" class="case-card-block-line" @click="isAnnotate = false"><i-->
<!--                class="iconfont icon-jinruyuedumoshi"></i>进入阅读模式-->
<!--              </div>-->
<!--              <div class="case-card-block-line" @click="goTo('/chat')" v-if="caseDetailValue.mentor_id"><i-->
<!--                class="iconfont icon-jinruduihua"></i>进入对话-->
<!--              </div>-->
<!--              <div class="case-card-block-line" @click="goHelp" v-else><i-->
<!--                class="iconfont icon-jinruduihua"></i>立即协助-->
<!--              </div>-->
<!--            </div>-->
            <div class="case-card-block">
              <div class="case-card-block-line" @click="menuChange('data')"><i class="iconfont icon-chakanziliao"></i>查看其他资料
              </div>
<!--              <div v-if="cardDetail.type_id != 5" class="case-card-block-line" @click="goToCardDetail"><i-->
<!--                class="iconfont icon-bianjiziliao"></i>编辑资料卡-->
<!--              </div>-->
<!--              <div class="case-card-block-line" @click="showAddDialog = true"><i class="iconfont icon-xinjian"></i>新增资料卡-->
<!--              </div>-->
              <div class="case-card-block-line" @click="innerVisible = true"><i
                class="iconfont icon-zhibeiyunfenxi"></i>智贝云分析
              </div>
              <div class="case-card-block-line" @click="goAnnotate"><i
                class="iconfont" :class="isAnnotate ? 'icon-jinruyuedumoshi':'icon-jinrupizhumoshi'"></i>{{ isAnnotate ? '进入阅读模式' : '进入批注模式' }}
              </div>
            </div>
          </div>

          <div v-if="dialogMenu == 'card'" class="case-card-detail-right"
               style="height: 90vh;overflow-y: auto">
            <div style="position: relative" ref="cardRightCont">
              <div class="case-card-detailtitle d-flex-between">
                <div>{{ cardDetail.type_name }} {{ cardDetail.card_date }}</div>
                <div class="d-flex">
                  <div class="add-btn case-card-btn" v-if="isAnnotate" @click="saveNotis">保存批注</div>
                  <div class="add-btn case-card-btn" @click="goTo('/chat')" v-if="caseDetailValue.mentor_id != null"><i
                    class="iconfont icon-jinruduihua"></i>进入对话
                  </div>
                  <div class="add-btn case-card-btn" @click="goHelp" v-else-if="member.member_type == 1"><i
                    class="iconfont icon-jinruduihua"></i>立即协助
                  </div>
                </div>

              </div>
              <div ref="cardRightCont">
              <div v-if="cardDetail.type_id == 4" style="position: relative">
                <img v-if="!isAnnotate  && cardDetail.pizhu_img" :src="cardDetail.pizhu_img" alt="" class="tuxiang-cover">
                <Zwibbler v-if="isAnnotate" ref="zwibblerTx" :dataInfo1="pizhu_img" :height="fileList.height"
                          :width="fileList.width" @showTrack="showTrackChange"></Zwibbler>
                <div class="d-flex-between tuxiang-title">
                  <div class="tuxiang-title-txt">正在进行的诊疗：<span>{{ cardDetail.being_treatment }}</span></div>
                  <div class="tuxiang-title-txt">复诊次数：<span>{{ cardDetail.fz_cc }}</span></div>
                </div>
                <div class="tuxiang-cont">
                  <div v-for="(item,index) in cardDetail.image_card_list" class="tuxiang-item">
                    <div class="tuxiang-title-txt">图片{{ index + 1 }}</div>
                    <div class="d-flex-warp">
                      <el-image
                        v-for="(subItem,subIndex) in item.img"
                        :preview-src-list="item.img"
                        :src="subItem"
                        class="tuxiang-item-img"
                        fit="cover"
                        style="width: 149px; height: 153px">
                      </el-image>
                    </div>
                    <div class="tuxiang-title-txt">{{ item.text }}</div>
                  </div>
                </div>
              </div>
              <div v-if="cardDetail.type_id == 5">
                <div class="sheji-cont">
                  <div class="tuxiang-title-txt"><span>{{
                      caseDetailValue.confirm_first_case_type_text ? '确认套餐类型' : '期望套餐类型'
                    }}：</span><span class="black-14">{{
                      caseDetailValue.confirm_first_case_type_text ? caseDetailValue.confirm_first_case_type_text : caseDetailValue.first_case_type_name
                    }}</span></div>
                  <img :src="cardDetail.shejidan_img" alt="" class="sheji-img-btm">
                  <img v-if="!isAnnotate && cardDetail.pizhu_img" :src="cardDetail.pizhu_img" alt="" class="sheji-img-cover">
                  <Zwibbler v-if="isAnnotate" ref="zwibblerSj" :dataInfo1="pizhu_img" :height="cardNoteHeight"
                            :width="828" @showTrack="showTrackChange"></Zwibbler>
                </div>
              </div>
              <div v-if="cardDetail.type_id != 4 && cardDetail.type_id != 5" class="d-flex-between"
                   style="position: relative">
                <div class="case-detail-img">
                  <div class="detail-img-3-l">
                    <el-image
                      :preview-src-list="[cardDetail.cemian_pic]"
                      :src="cardDetail.cemian_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zhengmian_pic]"
                      :src="cardDetail.zhengmian_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zhengmian_weixiao_pic]"
                      :src="cardDetail.zhengmian_weixiao_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                  </div>
                  <div class="detail-img-3-s">
                    <el-image
                      :preview-src-list="[cardDetail.youce_yaohe_pic]"
                      :src="cardDetail.youce_yaohe_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zhengwei_yaohe_pic]"
                      :src="cardDetail.zhengwei_yaohe_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zuoce_yaohe_pic]"
                      :src="cardDetail.zuoce_yaohe_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                  </div>
                  <div class="detail-img-1">
                    <el-image
                      :preview-src-list="[cardDetail.quanjing_pic]"
                      :src="cardDetail.quanjing_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                  </div>
                  <div class="detail-img-1-2">
                    <el-image
                      :preview-src-list="[cardDetail.ceweimian_x_pic]"
                      :src="cardDetail.ceweimian_x_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <div class="detail-img-1-2-right">
                      <el-image
                        :preview-src-list="[cardDetail.shanglingyalie_pic]"
                        :src="cardDetail.shanglingyalie_pic">
                        <div slot="error" class="image-slot">
                          <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                        </div>
                      </el-image>
                      <el-image
                        :preview-src-list="[cardDetail.xialingyalie_pic]"
                        :src="cardDetail.xialingyalie_pic">
                        <div slot="error" class="image-slot">
                          <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="detail-img-3-s">
                    <el-image
                      :preview-src-list="[cardDetail.fuhe_fugai_pic]"
                      :src="cardDetail.fuhe_fugai_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zhengmian_kaikou_zhao]"
                      :src="cardDetail.zhengmian_kaikou_zhao">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[cardDetail.zhengmian_yangshi_pic]"
                      :src="cardDetail.zhengmian_yangshi_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                  </div>
                </div>
                <div class="case-detail-txt">
                  <div class="case-detail-info">
                    <div class="case-detail-info-line">
                      <div class="case-info-name">姓名</div>
                      <div class="case-info-cont">{{ cardDetail.patient.name }}</div>
                    </div>
                    <div class="case-detail-info-line">
                      <div class="case-info-name">病例年龄</div>
                      <div class="case-info-cont">{{ cardDetail.patient.age_text }}</div>
                    </div>
                    <div class="case-detail-info-line">
                      <div class="case-info-name">首诊主诉</div>
                      <div class="case-info-cont" style="width: 100%">{{ cardDetail.patient.case_info }}</div>
                    </div>
                    <div v-if="cardDetail.type_id == 2 || cardDetail.type_id == 3" class="case-detail-info-line">
                      <div class="case-info-name">{{ cardDetail.type_id == 2 ? '复诊' : '会诊' }}情况</div>
                      <div class="case-info-cont" style="width: 100%">{{ cardDetail.being_treatment }}</div>
                    </div>
                    <div class="case-detail-info-line">
                      <div class="case-info-name">
                        {{ cardDetail.patient.confirm_first_case_type_text ? '确认' : '期望' }}套餐类型
                      </div>
                      <div class="case-info-cont" style="width: 100%">{{
                          cardDetail.patient.confirm_first_case_type_text ? cardDetail.patient.confirm_first_case_type_text : cardDetail.patient.first_case_type_name
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="case-detail-info">
                    <div class="case-detail-info-title d-flex-between">
                      <div class="case-info-cont">病历记录</div>
                      <div class="add-btn case-card-btn" @click="illWrite">{{ isWrite ? '保存' : '填写' }}</div>
                    </div>
                    <div class="ill-part">
                      <div class="case-info-name">难度标记</div>
                      <el-dropdown style="width: 100%" trigger="click" @command="difficultyChange">
                        <div :class="isWrite ? 'ill-white-bg':''" class=" d-flex-between ill-grey-bg">
                          <div class="ill-dropdown"><span
                            v-if="cardDetail.difficulty_level">{{ cardDetail.difficulty_level }}级</span></div>
                          <div class="iconfont icon-youjiantou"></div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="item in writeCode.app_patient_difficulty_level" :command="item.name">
                            {{ item.name }}级
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div v-if="cardDetail.type_id != 2 && cardDetail.type_id != 3" class="ill-part">
                      <div class="case-info-name">首诊牙列期</div>
                      <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.yalieqi" :class="cardDetail.yalieqi == item.name ? 'ill-on' : ''"
                             class="black-14"
                             @click="writeChange('yalieqi',item.name)">{{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="cardDetail.type_id != 2 && cardDetail.type_id != 3" class="ill-part">
                      <div class="case-info-name">首诊牙列替换完成时间</div>
                      <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.yalietihuanwanchengshijian"
                             :class="cardDetail.yalie_tihuan_finish_time == item.name ? 'ill-on' : ''"
                             class="black-14"
                             @click="writeChange('yalie_tihuan_finish_time',item.name)">{{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="cardDetail.type_id != 2 && cardDetail.type_id != 3" class="ill-part">
                      <div class="case-info-name">首诊牙列拥挤度</div>
                      <div class="small-grey-line d-flex-between">
                        <div class="black-14">上颌</div>
                        <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                          <div v-for="item in writeCode.shangheyalieyongjidu"
                               :class="cardDetail.shanghe_yalie_yongji_rate == item.name ? 'ill-on' : ''"
                               class="black-14"
                               @click="writeChange('shanghe_yalie_yongji_rate',item.name)">{{
                              item.name
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="small-grey-line d-flex-between">
                        <div class="black-14">下颌</div>
                        <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                          <div v-for="item in writeCode.xiaheyalieyongjidu"
                               :class="cardDetail.xiahe_yalie_yongji_rate == item.name ? 'ill-on' : ''"
                               class="black-14"
                               @click="writeChange('xiahe_yalie_yongji_rate',item.name)">{{ item.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ill-part">
                      <div class="case-info-name">侧貌面型</div>
                      <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.cemaomianxing"
                             :class="cardDetail.cemao_mianxing == item.name ? 'ill-on' : ''"
                             class="black-14"
                             @click="writeChange('cemao_mianxing',item.name)">{{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="cardDetail.type_id != 2 && cardDetail.type_id != 3" class="ill-part">
                      <div class="case-info-name">生长评估期</div>
                      <img alt="" src="../../assets/img/case_management/cs-table.png"
                           style="width: 100%;margin-bottom: 10px">
                      <el-dropdown style="width: 100%" trigger="click" @command="groupChange">
                        <div :class="isWrite ? 'ill-white-bg':''" class=" d-flex-between ill-grey-bg">
                          <div class="ill-dropdown">
                            {{
                              cardDetail.shengzhangqi_pinggu ? cardDetail.shengzhangqi_pinggu : writeCode.shengzhangqipinggu[0].name
                            }}
                          </div>
                          <div class="iconfont icon-youjiantou"></div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="item in writeCode.shengzhangqipinggu" :command="item.name">
                            {{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="ill-part">
                      <div class="case-info-name">龋齿</div>
                      <div :class="isWrite ? 'ill-white-bg':''" class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.quchi" :class="cardDetail.quchi == item.name ? 'ill-on' : ''"
                             class="black-14"
                             @click="writeChange('quchi',item.name)">{{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div class="ill-part">
                      <div class="case-info-name">诊疗建议</div>
                      <textarea v-model="writeOption.treat_proposal" :class="isWrite ? 'ill-white-bg':''"
                                class="black-14 ill-grey-textarea"></textarea>
                    </div>
                  </div>
                </div>
                <img v-if="!isAnnotate && cardDetail.pizhu_img" :src="cardDetail.pizhu_img" class="sheji-img-cover"
                     style="width: 828px;object-fit: contain" :style="{height:'cardNoteHeight'}">
                <Zwibbler v-if="isAnnotate" ref="zwibbler" :dataInfo1="pizhu_img" :height="cardNoteHeight"
                          :width="828" @showTrack="showTrackChange"></Zwibbler>
              </div>
             </div>
            </div>
          </div>
          <div v-if="dialogMenu == 'data'" :class="isMangeData ? 'pad-btm-btn' : ''" class="case-card-detail-right">
            <div class="case-card-detailtitle d-flex-between">
              <div>其他资料</div>
              <div v-if="!isMangeData" class="add-btn case-card-btn" @click="isMangeData = true">编辑</div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充视频资料</div>
              <div class="case-upload-line">
                <div v-if="!isMangeData" >
                  <el-upload drag accept="video/*" :show-file-list="false" :http-request="handleVideoChangePre" class="upload-video"
                             :action="'mp4'">
                    <img alt="" class="upload-video-bg" src="../../assets/img/case_management/upload-video-bg.png">
                    <img alt="" class="upload-video-icon" src="../../assets/img/case_management/upload-video-icon.png">
                    <div class="black-14">上传视频</div>
                  </el-upload>
                </div>
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.media">
                  <div v-for="item in otherCardData.other_media_json.media" class="upload-video-item">
                    <video :src="item.url" :poster="item.fm_img" controls></video>
                    <div>MP4</div>
                    <img v-if="isMangeData" alt="" class="upload-del" src="../../assets/img/case_management/del.png"
                         @click="editOtherData(item,'mp4')">
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充文件资料</div>
              <div class="case-upload-line">
                <div v-if="!isMangeData">
                  <el-upload drag accept=".pdf" :show-file-list="false" :http-request="handleVideoChangePre" class="upload-file"
                             :action="'pdf'">
                    <img alt="" class="upload-file-bg" src="../../assets/img/case_management/upload-file-bg.png">
                    <img alt="" class="upload-file-icon" src="../../assets/img/case_management/upload-file-icon.png">
                    <div class="black-14">上传文件</div>
                    <div class="grey-12">仅支持.pdf 格式</div>
                  </el-upload>
                </div>
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.file">
                  <div v-for="item in otherCardData.other_media_json.file" class="upload-file-item"
                       @click="openUrl(item.url)">
                    <div class="upload-file-item-icon">
                      <img alt="" src="../../assets/img/case_management/upload-file.png">
                    </div>
                    <div class="upload-file-item-name limit-2">{{ item.title }}</div>
                    <img v-if="isMangeData" class="upload-del" src="../../assets/img/case_management/del.png"
                         @click.stop="editOtherData(item,'pdf')">
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">智贝云分析报告</div>
<!--              <div class="case-upload-line">-->
<!--                <div v-for="i in 2" class="upload-file-item">-->
<!--                  <div class="upload-file-item-icon">-->
<!--                    <img alt="" src="../../assets/img/case_management/upload-report.png">-->
<!--                  </div>-->
<!--                  <div class="upload-file-item-name limit-1">侧位片分析</div>-->
<!--                  <div class="upload-file-item-time">2023.09.26</div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
          <div v-if="isMangeData" class="annotate-btn">
            <div @click="quiteUpdataOtherData">退出管理</div>
            <div @click="saveUpdateOtherData">保存当前操作</div>
          </div>

        </div>
      </el-dialog>

      <!--      解锁全周期弹窗-->
      <el-dialog
        :visible.sync="showCycleDialog"
        custom-class="take-dialog"
        title="全周期辅导咨询"
        width="354px">
        <div class="cycle-line1">全周期病例辅导，将由临床实战经验极其丰富的指导医师，为该病例提供详细治疗方案。</div>
        <div class="cycle-line2">
          <img alt="" src="@/assets/img/chat/left-line.png">
          <div>解锁即享以下权益</div>
          <img alt="" src="@/assets/img/chat/right-line.png">
        </div>
        <div class="cycle-info">
          <div><img alt="" src="@/assets/img/chat/gou.png">解除首诊卡咨询限制，至时长结束</div>
          <div><img alt="" src="@/assets/img/chat/gou.png">每月1次复诊辅导，直至病例结束</div>
          <div><img alt="" src="@/assets/img/chat/gou.png">每3个月1次会诊，直至病例结束</div>
          <div><img alt="" src="@/assets/img/chat/gou.png">协助您填写矫治器设计单，直至病例结束</div>
        </div>
        <div></div>
        <div></div>
        <div class="take-dialog-bottom">
          <div class="take-dialog-close" @click="showCycleDialog = false">暂不解锁</div>
          <div class="take-dialog-open" @click="luckChat">立即解锁</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {cardList} from '@/assets/js/case-card'
import Zwibbler from '@/components/Zwibbler'
import {
  Assist,
  CreateTeam, CurUserIsInGroup,
  DeleteCaseCard,
  GenerateBigCase,
  GetCaseCardInfo,
  GetCaseCardList, GetCaseInfo,
  GetCaseList,
  GetListByTypeCode,
  GetLpyxjzWebUrl,
  GetOtherInfo,
  ReceiveHcData,
  SavePizhu2,
  ToFullConsult,
  UpdateCaseCard,
  UpdateOtherInfo
} from "@/http/api";
import ossUpload from "@/http/ossUpload";
import {compressionImage, fileProcess} from "@/assets/js/imgHandle";
import {caseSortList} from "@/assets/js/caseSortList";

export default {
  name: "index",
  components: {Zwibbler},
  data() {
    return {
      showCycleDialog: false,//显示解锁全周期弹窗
      caseListModule:true,//列表模式
      addTypeList: [
        {
          name: '复诊卡',
          des: '病例复诊后创建，记录复诊情况',
          url: 'type1.png'
        },
        {
          name: '会诊卡',
          des: '面对疑难病例提出会诊申请，多导师协助诊疗',
          url: 'type2.png'
        },
        {
          name: '图像卡',
          des: '作为病例的补充图像资料',
          url: 'type3.png'
        },
        {
          name: '设计单',
          des: '创建矫治器加工卡设计单，导师协助定制方案',
          url: 'type4.png'
        },
        {
          name: '功能矫治器',
          des: '创建矫治器加工单，需绑定已完成的设计单',
          url: 'type5.png'
        },
        {
          name: '隐形矫治器加工',
          des: '创建隐形矫治器建工单，需绑定已完成的复诊卡',
          url: 'type6.png',
          isDL: true
        }
      ],
      showAddDialog: false,
      addType: -1,
      member: JSON.parse(localStorage.getItem('member')),
      typeNavList: [
        {id: 0, name: '全部'},
        {id: 2, name: '复诊'},
        {id: 3, name: '会诊'},
        {id: 4, name: '图像'},
        {id: 5, name: '设计'},
        {id: [6, 7], name: '加工'}
      ],
      orderIndex:0,
      orderSortIndex:[0,0,0,0,0,0],
      orderList: caseSortList,
      typeValue: 0,
      cardList: cardList,
      isManage: false,
      showCaseCardDetail: false,
      isAnnotate: false,
      dialogMenu: 'card',
      isMangeData: false,
      innerVisible: false,
      serviceList: [
        '侧位片分析',
        '颈椎骨龄',
        '面型分析',
        '面型分析'
      ],
      keyWords:'',
      serviceIndex: -1,
      caseList: [],
      case_type: 0,
      loadStatus: '',
      cardloadStatus: '',
      page: 1,
      caseDetailValue: {},
      caseCardList: [],
      cardDetail: {},
      isWrite: false,
      writeCode: {},
      writeOption: {
        difficulty_level: '',
        yalieqi: '',
        yalie_tihuan_finish_time: '',
        shanghe_yalie_yongji_rate: '',
        xiahe_yalie_yongji_rate: '',
        cemao_mianxing: '',
        shengzhangqi_pinggu: '',
        quchi: '',
        treat_proposal: ''
      },
      designModel: [],
      showDesignDioalog: false,
      designType: {},
      delCardIds: [],
      otherCardData: {},
      firstInit: true,
      showHcDialog: false,
      hcList: [],
      pizhu_img: '',
      fileList: {},
      doctor_id:this.$route.query.doctor_id ? this.$route.query.doctor_id : '', //路由带的医生id
      cardNoteHeight:undefined,
      showTrack:true, //显示轨迹
      joinLoading:false
    }
  },
  mounted() {


    let _that = this
    this.initCaseData(true)

    this.initCode()
    //监听列表滚动触底刷新
    this.$nextTick(() => {
      _that.$refs.leftCaseRef.addEventListener('scroll', (e) => {
        var scrollTop = e.target.scrollTop
        var windowHeight = e.target.clientHeight
        var scrollHeight = e.target.scrollHeight
        if (scrollTop + windowHeight >= scrollHeight - 20) {
          // 当前滚动条已经触底
          _that.initCaseData()
        }
      });
    })
  },
  methods: {
    initCode() {
      GetListByTypeCode({type_code: ['app_patient_difficulty_level', 'yalieqi', 'yalietihuanwanchengshijian', 'shangheyalieyongjidu', 'xiaheyalieyongjidu', 'cemaomianxing', 'shengzhangqipinggu', 'quchi']})
        .then(res => {
          this.writeCode = res.data
        })
      GetListByTypeCode({type_code: ['shejidanmoban']}).then(res => {
        this.designModel = res.data.shejidanmoban
      })
    },
    initCardOtherData() {
      GetOtherInfo({card_id: this.cardDetail.id}).then(res => {
        this.otherCardData = res.data
      })
    },
    changeType(id) {
      this.typeValue = id
      this.initCaseCardData()
    },
    changeCaseType(val) {
      this.case_type = val
      this.initCaseData(true)
    },
    addTypeChange(i) {
      this.addType = i
    },
    goAnnotate() {
      if(this.isAnnotate){
        this.isAnnotate = false
        return false
      }
      let _that = this
      if (this.cardDetail.pizhu_img) {
        console.log('有批注')
        fileProcess(this.cardDetail.pizhu_img, new Date().getTime() + '.png').then(fileList => {
          let scale = fileList.width / 828
          _that.fileList.width = 828
          _that.fileList.height = (fileList.height / scale).toFixed(0)
          compressionImage(fileList.raw, 828, _that.fileList.height).then(fileRes => {
            ossUpload.bucketUpload(fileRes, (res) => {
              this.pizhu_img = res.url
              this.isAnnotate = true
            }, (err) => {
              this.pizhu_img = ''
              this.isAnnotate = true
            }, 'duole-images', '/upload/image/pc/temp/')
          })

          // if (this.cardDetail.type_id == 4) {
          //   compressionImage(fileList.raw, 828, _that.fileList.height).then(fileRes => {
          //     ossUpload.bucketUpload(fileRes, (res) => {
          //       this.pizhu_img = res.url
          //       this.isAnnotate = true
          //     }, (err) => {
          //       this.pizhu_img = ''
          //       this.isAnnotate = true
          //     }, 'duole-images', '/upload/image/pc/temp/')
          //   })
          // } else {
          //   compressionImage(fileList.raw, 828, 1123).then(fileRes => {
          //     ossUpload.bucketUpload(fileRes, (res) => {
          //       this.pizhu_img = res.url
          //       this.isAnnotate = true
          //     }, (err) => {
          //       this.pizhu_img = ''
          //       this.isAnnotate = true
          //     }, 'duole-images', '/upload/image/pc/temp/')
          //   })
          // }
        })
      }else{
        this.pizhu_img = ''
        this.isAnnotate = true
      }
    },
    menuChange(txt) {
      if (this.dialogMenu == 'card' && txt == 'card') {
        this.showCaseCardDetail = false
      } else {
        this.dialogMenu = txt
      }
      this.isMangeData = false
      this.isAnnotate = false
    },
    serviceChange(i) {
      this.serviceIndex = i
    },
    initCaseData(isRefresh) {
      // 清空导航栏带的参数
      // if( !this.firstInit) this.$router.replace('/case_management')
      if (!this.$store.state.workState) return false
      var _that = this
      if (isRefresh) {
        this.caseList = []
        this.page = 1
        this.caseDetailValue = {}
      } else if (this.loadStatus == 'over') {
        return
      }
      this.loadStatus = 'load'
      let orderBy = []
      orderBy.push(this.orderList[this.orderIndex].param)
      orderBy.push(this.orderList[this.orderIndex].param_order[this.orderSortIndex[this.orderIndex]])
      let option = {
        orderBy: orderBy,
        page: this.page,
        pageSize: 22,
        keyWords:this.keyWords,

        doctor_id : this.$route.query.doctor_id,
        case_type : 0
      }
      //导师查看医生的案例
      // if (this.$route.query.doctor_id) {
      //   option.doctor_id = this.$route.query.doctor_id
      //   //case_type  0 咨询病例 1 管理病例
      //   option.case_type = 0
      // } else {
      //   if(this.$route.query.new == 1) this.case_type = 1
      //
      //   if (this.member.member_type == 0) option.case_type = this.case_type
      //   if (this.member.member_type == 1 || this.member.member_type == 4 || this.member.member_type == 5) option.case_type = 1
      //   option.doctor_id = this.member.id
      // }

      this.$store.commit('workStart')
      GetCaseList(option).then(res => {
        let currentData = res.data.data
        _that.caseList = _that.caseList.concat(currentData)
        if (res.data.current_page >= res.data.last_page) {
          _that.loadStatus = 'over'
        } else {
          _that.loadStatus = ''
          _that.page += 1
        }
        this.$store.commit('workOver')
        //判断是否是别的页面返回的
        if (this.$route.query.id && this.firstInit) {
          res.data.data.forEach(item => {
            if (item.id == this.$route.query.id) this.chooseCaseDetail(item)
          })
        }else{
          this.firstInit = false
        }
        if(isRefresh){
          if (this.$route.query.doctor_id && res.data.data.length) this.$store.commit('breadChange', {
            name: res.data.data[0].doctor_name + '医生的病例',
            isBack: true
          })
          else if(this.$route.query.name) this.$store.commit('breadChange', {
            name: this.$route.query.name + '医生的病例',
            isBack: true
          })
          else this.$store.commit('breadChange', {name: '病例管理', isBack: false})
        }

      })
    },
    orderChange(i) {
      this.orderIndex = i
      this.initCaseData(true)
    },
    orderSortChange(i) {
      this.$set(this.orderSortIndex,i,Math.abs(this.orderSortIndex[i] - 1))
      if(i == this.orderIndex) this.initCaseData(true)
    },
    chooseCaseDetail(val) {
      this.caseDetailValue = val
      //每次切换病例时恢复资料卡类型
      this.typeValue = 0
      this.initCaseCardData()
    },
    initCaseCardData() {
      this.caseCardList = []
      this.cardloadStatus = 'load'
      GetCaseCardList({patient_id: this.caseDetailValue.id, type_id: this.typeValue, pageSize: 999}).then(res => {
        if (res.data.length) {
          this.caseCardList = res.data
          this.cardloadStatus = ''
        } else {
          this.cardloadStatus = 'over'
        }
        //判断是否是别的页面返回的
        if (this.$route.query.card_id && this.firstInit) {
          this.firstInit = false
          res.data.forEach(item => {
            if (item.id == this.$route.query.card_id) this.openCardPup(item, item.type_id)
          })
        }else{
          this.firstInit = false
        }
      })
    },
    openHcDialog() {
      this.showHcDialog = true
      ReceiveHcData({patient_id: this.caseDetailValue.id}).then(res => {
        this.hcList = res.data
      })
    },
    openCardPup(val, type) {
      if (this.isManage) {
        //管理模式下点击卡片后勾选
        if (type != 1) {
          let i = this.delCardIds.indexOf(val.id)
          if (i == -1) {
            this.delCardIds.push(val.id)
          } else {
            this.delCardIds.splice(i, 1)
          }
        }
      } else {
        //非管理模式下点击卡片打开
        if (type == 7) {
          GetLpyxjzWebUrl({patient_id: this.caseDetailValue.id}).then(res => {
            this.openUrl(res.data.web_url)
          })
        } else if (type == 6) {
          let newUrl = this.$router.resolve({
            name: '订单详情',
            query: {
              id: val.order_id
            }
          })
          this.openUrl(newUrl.href)
        } else if (this.caseDetailValue.finished_status == 1) {
          let url = this.$router.resolve({
            name: '大病案',
            query: {
              id: this.caseDetailValue.id
            }
          })
          window.open(url.href, '_blank')
        } else {
          this.cardDetail = val
          this.showCaseCardDetail = true
          this.initCardOtherData()
          this.writeOption.treat_proposal = this.cardDetail.treat_proposal
          this.$set(this.cardDetail, 'difficulty_level', val.patient.difficulty_level)
          this.isWrite = false
          this.$nextTick(()=>{
            this.cardNoteHeight = this.$refs.cardRightCont.clientHeight
            console.log(this.cardNoteHeight)
            //保持一点间隔
            // setTimeout(()=>{
            //   this.goAnnotate()
            // },1000)
          })
        }
      }
    },
    delCard() {
      if (!this.delCardIds.length) {
        this.$message({
          type: 'info',
          message: '请选择需要删除的资料卡'
        })
        return false
      }
      this.$confirm('确定删除选中的资料卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DeleteCaseCard({ids: this.delCardIds}).then(res => {
          if (res.code == 200) {
            if (res.data.msg.length) {
              res.data.msg.forEach(item => {
                this.$message({
                  type: 'error',
                  message: item
                })
              })
            } else {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
            }
            this.isManage = false
            this.delCardIds = []
            this.initCaseCardData()
          }

        })
      })
    },
    goTo(url) {
      if (url == '/chat') {
        if (this.caseDetailValue.im_group_id) {
          //有群id 的情况再判断有无导师id
          if(!this.caseDetailValue.mentor_id){
            this.$alert('工作时间2小时内分配导师进行咨询', '暂无导师咨询', {
              confirmButtonText: '确定',
            });
            return false
          }
          this.joinLoading = true
          CurUserIsInGroup({patient_id:this.caseDetailValue.id}).then(res=>{
            this.joinLoading = false
            if(res.data.exists) {
              this.$router.push({
                name: '会话框',
                query: {
                  // id: this.,
                  case_id: this.caseDetailValue.id,
                  card_id: this.showCaseCardDetail ? this.cardDetail.id : this.caseCardList[0].id
                }
              })
            }else{
              this.$message({
                type:'info',
                message:'您未在该聊天群中，无法进入会话'
              })
            }
          })
        } else {
          CreateTeam({patient_id: this.caseDetailValue.id}).then(res => {
            if (res.code == 200) {
              if(res.data.mentor_id){
                this.$router.push({
                  name: '会话框',
                  query: {
                    case_id: this.caseDetailValue.id,
                    card_id: this.showCaseCardDetail ? this.cardDetail.id : this.caseCardList[0].id
                  }
                })
              }else{
                this.$alert('工作时间2小时内分配导师进行咨询', '暂无导师咨询', {
                  confirmButtonText: '确定',
                  // callback: action => {
                  //
                  // }
                });
              }
            }
          })
        }
      } else if (url == '/case_management/add_card') {
        this.showCaseCardDetail = false
        if (this.caseDetailValue.first_case_type != 4 && this.addType == 5) {
          this.$message({
            type: 'info',
            message: '该病例还未订购多乐X乐普乐齐的联动套餐"快乐+"，请订购后再创建隐形矫治器加工卡。'
          })
        } else if (this.addType == 4 && this.caseDetailValue.confirm_first_case_type == null) {
          this.$message({
            type: 'info',
            message: '请先联系管理员确认套餐类型。'
          })
        } else if (this.addType == 4 && this.caseDetailValue.case_type == 1) {
          this.$message({
            type: 'info',
            message: '非咨询病例不可创建。'
          })
        } else if (this.addType == 3) {
          this.showDesignDioalog = true
          this.designType = {}
        } else {
          let url = this.$router.resolve({
            name: '新增资料卡',
            query: {
              name: this.addTypeList[this.addType].name,
              id: this.caseDetailValue.id,
            }
          })
          window.open(url.href, '_blank')
        }

      } else this.$router.push(url)
    },
    goToCardDetail() {
      this.$confirm("修改资料可能会导致批注和内容不符，是否修改资料?", "修改资料", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          name: '编辑资料卡',
          query: {
            id: this.caseDetailValue.id,
            card_id: this.cardDetail.id,
          }
        })
      });
    },
    addDesignCard() {
      window.open('/case_management/add_design_card?patient_id=' + this.caseDetailValue.id + '&shejidan_id=' + this.designType.id, '_blank')
    },
    illWrite() {
      if (this.isWrite) {
        this.writeOption.id = this.cardDetail.id
        UpdateCaseCard(this.writeOption).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.initCaseCardData()
          } else {
            this.$message.error('修改失败');
            this.isWrite = false
          }
        })
      } else {

      }
      this.isWrite = !this.isWrite
    },
    difficultyChange(e) {
      this.writeOption.difficulty_level = e
      this.cardDetail.difficulty_level = e
    },
    groupChange(e) {
      this.writeOption.shengzhangqi_pinggu = e
      this.cardDetail.shengzhangqi_pinggu = e
    },
    writeChange(name, val) {
      this.writeOption[name] = val
      this.cardDetail[name] = val
    },
    saveNotis() {
      if(!this.showTrack){
        this.showTrack = true
        return false
      }
      var blob = ''
      if (this.cardDetail.type_id == 4) blob = this.$refs.zwibblerTx.saveTu()
      else if (this.cardDetail.type_id == 5) blob = this.$refs.zwibblerSj.saveTu()
      else blob = this.$refs.zwibbler.saveTu()
      ossUpload.bucketUpload(blob, (res) => {
        SavePizhu2({id: this.cardDetail.id, pizhu_img: res.url}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.initCardDetailData()
            this.initCaseCardData()
          } else {
            this.$message({
              type: 'error',
              message: res.message[0]
            })
          }
        })
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/')
    },
    initCardDetailData() {
      GetCaseCardInfo({id: this.cardDetail.id}).then(res => {
        this.cardDetail = res.data
      })
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    handleVideoChangePre(e){
      this.handleVideoChange(e.file,e.action)
    },
    handleVideoChange(file, type) {
      ossUpload.bucketUpload(file, (res) => {
        let obj = {
          title: res.attachment,
          url: res.url,
          fm_img: res.url + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto',
        }
        if (Object.prototype.toString.call(this.otherCardData.other_media_json) === '[object Object]') {
          if (type == 'mp4') {
            if (this.otherCardData.other_media_json.media) {
              this.otherCardData.other_media_json.media.push(obj)
            } else {
              this.otherCardData.other_media_json.media = [obj]
            }
          } else {
            if (this.otherCardData.other_media_json.file) {
              this.otherCardData.other_media_json.file.push(obj)
            } else {
              this.otherCardData.other_media_json.file = [obj]
            }
          }
        } else {
          this.otherCardData.other_media_json = {}
          if (type == 'mp4') {
            this.otherCardData.other_media_json.media = [obj]
          } else {
            this.otherCardData.other_media_json.file = [obj]
          }
        }
        UpdateOtherInfo({
          card_id: this.cardDetail.id,
          other_media_json: this.otherCardData.other_media_json
        }).then(res2 => {
          if (res2.code == 200) {
            this.initCardOtherData()
            this.$message({
              type: "success",
              message: '上传成功'
            })
          }
        })
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/file/pc/')
    },
    editOtherData(val, type) {
      if (type == 'mp4') {
        let i = this.otherCardData.other_media_json.media.indexOf(val)
        this.otherCardData.other_media_json.media.splice(i, 1)
      } else {
        let i = this.otherCardData.other_media_json.file.indexOf(val)
        this.otherCardData.other_media_json.file.splice(i, 1)
      }
    },
    saveUpdateOtherData() {
      UpdateOtherInfo({
        card_id: this.cardDetail.id,
        other_media_json: this.otherCardData.other_media_json
      }).then(res2 => {
        if (res2.code == 200) {
          this.initCardOtherData()
          this.$message({
            type: "success",
            message: '编辑成功'
          })
          this.isMangeData = false
        }
      })
    },
    quiteUpdataOtherData() {
      this.isMangeData = false
      this.initCardOtherData()
    },
    openAddDialog() {
      this.showAddDialog = true
      this.addType = -1
    },
    initCaseDetail(){
      GetCaseInfo({id:this.caseDetailValue.id}).then(res=>{
        this.caseDetailValue = res.data
      })
    },
    createBigCase() {
      if(this.caseDetailValue.mentor_id){
        this.$confirm('是否结束此案例并生成大病案?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          GenerateBigCase({patient_id: this.caseDetailValue.id}).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '生成成功'
              })
              this.initCaseDetail()
            }
          })
        })
      }else{
        this.goHelp()
      }
    },
    goHelp(){
      Assist({patient_id:this.caseDetailValue.id}).then(res=>{
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '协助成功'
          })
          this.initCaseData()
          this.initCaseDetail()
        }
      })
    },
    luckChat() {
      this.showCycleDialog = false
      ToFullConsult({patient_id: this.caseDetailValue.id, from: 'info'}).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '解锁成功'
          })
          this.initCaseData(true)
        }
      })
    },
    showTrackChange(val) {
      console.log(val)
      this.showTrack = val
    },
  }
}
</script>

<style scoped src="../../assets/css/doctor-detail.css"></style>
<style scoped src="../../assets/css/case_management.css"></style>
<style>
.page-dialog, .page-dialog .el-dialog__header, .page-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.case-detail-img img {
  object-fit: contain;
  border: 1px dashed lightgrey;
}
/*上传图片样式*/
.upload-video .el-upload,.upload-file .el-upload{
  width: 100%;
  height: 100%;
}
.upload-video .el-upload-dragger,.upload-file .el-upload-dragger{
  width: 100%;
  height: 100%;
  border: none;
  padding-top: 13px;
}
.upload-file .el-upload-dragger{
  padding-top: 30px;
}
</style>
